import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { baseRoutes } from '../../constants/routes.constants';
import { RootState } from '../../store';

interface SearchEntryAuthGuardProps {
  children: React.ReactNode;
}

const SearchEntryAuthGuard: React.FC<SearchEntryAuthGuardProps> = ({ children }) => {
  const { isAuthenticated, authInitialized } = useSelector((state: RootState) => state.auth);

  if (!authInitialized) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={baseRoutes.signIn} replace state={{ from: baseRoutes.root }} />;
  }

  return <>{children}</>;
};

export default SearchEntryAuthGuard;
